import moment from 'moment';

const getShortDayMonthYear = (date, format) => {
  let newDate = format === 'UTC' ? moment(date).utc() : moment(date);
  const dd = moment(newDate).date();
  let mm = moment(newDate).month() + 1;
  let yy = moment(newDate).year();
  yy = yy.toString().substr(-2);
  return {
    dd,
    mm,
    yy
  };
};

const getPreviousDate = date => {
  return moment(date).subtract(1, 'days');
};

const getNextDate = date => {
  return moment(date).add(1, 'days');
};

const getDate = date => {
  if (date) moment(date);else moment();
};

export { getShortDayMonthYear, getDate, getPreviousDate, getNextDate };